import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=a8d3e410&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"
import style0 from "./Chatbot.vue?vue&type=style&index=0&id=a8d3e410&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d3e410",
  null
  
)

export default component.exports